import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const GenericGuideSectionText = (props) => {
    const [text, setText] = useState('');

    useEffect(() => {
        const regex = /\{([^}]+)\}/;    
        let match = props.iContent.text?.value.match(regex);
        let fixedText = props.iContent.text?.value;

        if(match?.length > 0) {
            fixedText = props.iContent.text?.value?.replace(regex, `<a href="#" class="copy-icon" onclick="copyTextToClipboard('${match[1]}')">${match[1]}</a>`);            
        } 
        setText(fixedText);

        window.copyTextToClipboard = copyTextToClipboard;
        return () => {
            delete window.copyTextToClipboard;
        }
    }, []);

    return (
        <div className='generic-guide-section-text' dangerouslySetInnerHTML={{ __html: text }}></div>
    );

    function copyTextToClipboard(textToCopy) {
        navigator.clipboard.writeText(textToCopy);
    }
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideSectionText);